import Cookies from 'js-cookie';
import React from 'react';

import { submitGenericForm } from '../../components/Common/MarketoForm/submitForm';

const COOKIE_BASE = '_fs_lcaccess';

const useSubmitDiscreetForm = (fields, programName, submitted) => {
  const [submitting, setSubmitting] = React.useState(false);
  React.useEffect(() => {
    const handleSubmit = async (cookieData) => {
      const checkCaptcha = async () => {
        if (typeof window !== 'undefined') {
          let tokenResponse;
          try {
            tokenResponse = await window?.grecaptcha?.execute(process.env.GATSBY_CAPTCHA_SITE_ID, {
              action: 'submit',
            });
            return tokenResponse;
          } catch (e) {
            return null;
          }
        }
      };

      if (cookieData?.programNames?.indexOf(programName) === -1 && !submitting) {
        setSubmitting(true);
        const captchaToken = await checkCaptcha();
        submitGenericForm(fields, cookieData.fields, programName, cookieData.fields?.Email, captchaToken);
        if (!cookieData.programNames) {
          cookieData.programNames = [programName];
        } else {
          cookieData.programNames.push(programName);
        }
        Cookies.set(COOKIE_BASE, JSON.stringify(cookieData));
      }
    };
    const userSettings = window?.Osano?.cm?.getConsent();
    const canStore = userSettings?.OPT_OUT === 'DENY' && userSettings?.STORAGE === 'ACCEPT';

    if (!canStore) return;

    let cookie = Cookies.get(COOKIE_BASE);
    let cookieData;
    if (cookie) {
      cookieData = JSON.parse(cookie);
    }

    if (cookieData?.programNames?.indexOf(programName) === -1)
      if (!submitted) {
        setTimeout(() => handleSubmit(cookieData), 10000);
      }
  });
};

const useCheckGatedCookie = (stateCallback, unlocked) => {
  React.useEffect(() => {
    const userSettings = window?.Osano?.cm?.getConsent();
    const canStore = userSettings?.OPT_OUT === 'DENY' && userSettings?.STORAGE === 'ACCEPT';

    if (!canStore && !unlocked) {
      stateCallback(false);
    } else {
      const unlockedCookie = Cookies.get(COOKIE_BASE);
      if (unlockedCookie) {
        stateCallback(true);
      } else {
        const cookies = Cookies.get();
        for (const key in cookies) {
          if (key.indexOf(COOKIE_BASE) > -1) {
            stateCallback(true);
            break;
          }
        }
      }
    }
  }, [unlocked, stateCallback]);
};

const setUnlockedCookie = (formId) => {
  if (!formId) {
    return;
  }
  const userSettings = window?.Osano?.cm?.getConsent();
  const canStore = userSettings?.OPT_OUT === 'DENY' && userSettings?.STORAGE === 'ACCEPT';
  if (!canStore) return;

  Cookies.set(COOKIE_BASE, 'true');
};

export { useCheckGatedCookie, useSubmitDiscreetForm, setUnlockedCookie };
